export const formatDate = (value: string) => {
  const [year, month, day] = value.split("-");
  return `${year}年${Number(month)}月${Number(day)}日`;
};

export const shortDate = (value: string) => value.replace(/-/g, ".");

export const formatCount = (value: number) => {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
};

export const daysAgo = (value: string) => {
  const target = new Date(`${value}T00:00:00`);
  const now = new Date("2025-10-18T00:00:00");
  const diff = Math.round((now.getTime() - target.getTime()) / 86400000);
  if (diff <= 0) return "今天";
  if (diff === 1) return "昨天";
  if (diff < 7) return `${diff} 天前`;
  return formatDate(value);
};